import { render, staticRenderFns } from "./MyprofileTypesCard.vue?vue&type=template&id=5ced7025&scoped=true"
import script from "./MyprofileTypesCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyprofileTypesCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyprofileTypesCard.vue?vue&type=style&index=0&id=5ced7025&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ced7025",
  null
  
)

export default component.exports